// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__s97gV","buttons":"SendReceipts_buttons__3bxHN","email":"SendReceipts_email__185s0","bookApptTitle":"SendReceipts_bookApptTitle__344Xf"};